import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';

@Injectable()
export class FnGoogleLocationService {
	constructor(private httpClient: HttpClient) {}

	private TIME_ZONE_API_URL =   'https://api.timezonedb.com/v2.1/get-time-zone';
	private TIME_ZONE_API_KEY =  'X2QY4PU74ZJP';
	private GOOGLE_API_KEY =  'AIzaSyC1c5k-YqgX3czTiqcqUzY5O6GkfUUjmwM';
	private GOOGLE_API_URL =  'https://maps.googleapis.com/maps/api/js?key=';

	setTimeZoneApiDetail(apiKey: string, url?: string) {
		this.TIME_ZONE_API_KEY = apiKey;
		if (url) {
			this.TIME_ZONE_API_URL = url;
		}
	}

	setGoogleApiDetail(apiKey: string, url?: string) {
		this.GOOGLE_API_KEY = apiKey;
		if (url) {
			this.GOOGLE_API_URL = url;
		}
	}

	getTimezonDetail(lat: string, lng: string): Observable<any> {
		const requestMap =
			this.TIME_ZONE_API_URL +
			'?format=json&by=position&lat=' +
			lat +
			'&lng=' +
			lng +
			'&key=' +
			this.TIME_ZONE_API_KEY;
		return this.httpClient.get(requestMap);
	}

	private isGoogleScriptLoaded(): boolean {
		return document.getElementById('google_map_loaded') != null;
	}

	private verifyScriptLoading(callback: any): void {
		setTimeout(() => {
			if (!this.isGoogleScriptLoaded()) {
				this.verifyScriptLoading(callback);
			} else {
				callback(true);
			}
		}, 1000);
	}

	loadGoogleScript(): Subject<any> {
		const returnSubject = new Subject();

		if (!this.isGoogleScriptLoaded()) {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.id = 'google_map_loaded';
			script.src =
				this.GOOGLE_API_URL + this.GOOGLE_API_KEY + '&libraries=places'; // TEST
			document.body.appendChild(script);
			this.verifyScriptLoading((isDone: boolean) => {
				returnSubject.next(true);
				returnSubject.complete();
			});
		} else {
			returnSubject.next(true);
			returnSubject.complete();
		}

		return returnSubject;
	}
}
